
























	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import {storeEssenceAchatsTotaux, EssenceAchatFilter} from '@/stores/modules/essenceAchat';

	import InputDateFilter from '@/components/Input/DateFilter.vue';
	import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
	import InputBoisType from "@/components/Input/BoisType.vue";
	import {DateFilterMode} from "@/shared/filter";

	@Component({
		components: {
			InputDateFilter,
			InputBoisType,
			CrudTransporteurSearch,
		}
	})
	export default class CrudEssenceAchatFilterTotauxEssenceAchats extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeEssenceAchatsTotaux) private page!: number;
		@Stored(() => storeEssenceAchatsTotaux) private filters!: EssenceAchatFilter;

		@WatchObjectProperties('filters', EssenceAchatFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeEssenceAchatsTotaux.dispatch( 'getTotauxEssenceAchats', { filters: true });
		}
		
		public mounted() {
		    this.typeWatcher();
			this.filters.totalParBoisType = true;
			this.filters.totalParLongueur = true;
		}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();

		}

		private get methodName(): string {
			return 'getTotauxEssenceAchats';
		}

		@Watch('order')
		@Watch('page')
		@Watch('direction')
		private refresh(): void {
			storeEssenceAchatsTotaux.dispatch(this.methodName, { filters: true });
		}
	}
